import { Carousal, Col, ModalPopup, Row, Card, Breadcrumb } from '../../CommonComponents'
import './CommonDashboard.scss'
import Spinner from "client/CommonComponents/Spinner";
import UserProfile from '../UserProfile';
import leadrlogo from '../../../client/assets/images/LEADR_Transparent.png';

interface IProps {
    newsAndAnnouncementDetails?: any,
    showUserManagementPopup?: any,
    hidePopup?: any,
    loading?: any,
    breadcrumlist?: any
}
const CommonDashboard = ({showUserManagementPopup, hidePopup,loading}:IProps) => {
    const webRebateAppBaseUrl = process.env.REACT_APP_WEBAPP_REBATE_API_BASE_URL
    const webBulkOrderAppBaseUrl = process.env.REACT_APP_WEBAPP_BULKORDER_API_BASE_URL
    return(<>
        {
            showUserManagementPopup
                ? <ModalPopup
                    ShowModalPopupFooter={false}
                    ModalPopupTitle="USER PROFILE"
                    ModalPopupType="medium-large"
                    ModalPopupName='userprofile-popup'
                 data-attribute="CommonDashboard_Default_ModalPopup">
                    <UserProfile closeModalPopup={hidePopup}/>
                </ModalPopup>
                : null
        }
        {
            loading && <Spinner text={'Loading ...'}  data-attribute="CommonDashboard_Default_Spinner" />
        }
        <Row className='common-dashboard'>

        </Row>
        <div className="logo_card">

            <Col xl={12}>
                <Row className='new_dashboard'>
                    <Col xl={3} lg={4} md={6} className="mb-3 logo_block">
                        <Card data-attribute="CommonDashboard_Default_Card">
                            <a href={'/ordermanagement'} rel='noreferrer noopener' target='_blank' className='logo_link'>
                                <img src={leadrlogo} alt='LEADR' className='mb-2 logo_image' />
                                <div className='logo_name'>ORDER MANAGEMENT</div>
                            </a>
                        </Card>
                    </Col>
                    <Col xl={3} lg={4} md={6} className="mb-3 logo_block">
                        <Card data-attribute="CommonDashboard_Default_Card_2">
                            <a href={`${webBulkOrderAppBaseUrl}/Inventory`} rel='noreferrer noopener' target='_blank' className='logo_link'>
                                <img src={leadrlogo} alt='LEADR' className='mb-2 logo_image' />
                                <div className='logo_name'>BULK ORDER INVENTORY SOLUTION</div>
                            </a>
                        </Card>
                    </Col>
                    <Col xl={3} lg={4} md={6} className="mb-3 logo_block">
                        <Card data-attribute="CommonDashboard_Default_Card_3">
                            <a href={'/assetinventory'} rel='noreferrer noopener' target='_blank' className='logo_link'>
                                <img src={leadrlogo} alt='LEADR' className='mb-2 logo_image' />
                                <div className='logo_name'>ASSET INVENTORY</div>
                            </a>
                        </Card>
                    </Col>
                    <Col xl={3} lg={4} md={6} className="mb-3 logo_block">
                        <Card data-attribute="CommonDashboard_Default_Card_4">
                            <a href={'/Admin/dashboard'} rel='noreferrer noopener' target='_blank' className='logo_link'>
                                <img src={leadrlogo} alt='LEADR' className='mb-2 logo_image' />
                                <div className='logo_name'>ADMINISTRATION</div>
                            </a>
                        </Card>
                    </Col>
                    <Col xl={3} lg={4} md={6} className="mb-3 logo_block">
                        <Card data-attribute="CommonDashboard_Default_Card_5">
                            <a href={webRebateAppBaseUrl} rel='noreferrer noopener' target='_blank' className='logo_link'>
                                <img src={leadrlogo} alt='LEADR' className='mb-2 logo_image' />
                                <div className='logo_name'>REBATE</div>
                            </a>
                        </Card>
                    </Col>
                </Row>
            </Col>


        </div>
    </>)
}

export default CommonDashboard
